export { default } from './BorrowingUtilityBar';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingUtilityBar/index.js